module.exports = __webpack_public_path__ + "54a760c6f362417c08287715769a3232.pdf";